var map = {
	"./add.svg": 1171,
	"./banner.svg": 1659,
	"./clock.svg": 6495,
	"./comment.svg": 8219,
	"./course.svg": 3849,
	"./dataquery.svg": 7406,
	"./edit.svg": 1606,
	"./event.svg": 8388,
	"./excel.svg": 4221,
	"./feedback.svg": 7635,
	"./help.svg": 5271,
	"./home.svg": 7744,
	"./house.svg": 3284,
	"./id.svg": 9749,
	"./img.svg": 134,
	"./inspection.svg": 4606,
	"./msg.svg": 1485,
	"./my.svg": 4259,
	"./plan.svg": 8963,
	"./police.svg": 1345,
	"./poster.svg": 7267,
	"./ring.svg": 1460,
	"./setting.svg": 5530,
	"./shop.svg": 4225,
	"./trash.svg": 1483,
	"./user.svg": 5159,
	"./users.svg": 5874,
	"./word.svg": 9915,
	"./write.svg": 1672,
	"./write2.svg": 2162,
	"./yellow-edit.svg": 8654
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;